import React from 'react';
import { DatePicker, MobileTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box, InputAdornment } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Form } from 'antd';

export default function DateTimeInput({ dateName, timeName, disabled = false  }) {
  const inputStyle = {
    border: '1px solid #d9d9d9',
    borderRadius: '6px',
    boxShadow: 'none',
    paddingRight: '12px',
    backgroundColor: '#fff',

    '&:hover': {
      borderColor: '#40a9ff',
    },
    '&.Mui-focused': {
      borderColor: '#40a9ff',
    },

    '&.Mui-disabled': {
      backgroundColor: '#f5f5f5',
      color: 'rgba(0,0,0,0.6)',
    },

    '& input.Mui-disabled': {
      WebkitTextFillColor: 'rgba(0,0,0,0.6)',
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
        <Form.Item
          name={dateName}
          noStyle
          rules={[{ required: true, message: 'Select a date' }]}
        >
          <DatePicker
            format="DD/MM/YYYY"
            disabled={disabled}
            slotProps={{
              popper: { sx: { zIndex: 9999 } },
              textField: {
                variant: 'standard',
                size: 'small',
                placeholder: 'DD/MM/YYYY',
                InputProps: { disableUnderline: true },
                sx: {
                  flexBasis: '66%',
                  flexGrow: 1,
                  '& input': {
                    padding: '6px 11px',
                    fontSize: 14,
                  },
                  '& .MuiInputBase-root': inputStyle,
                },
              },
            }}
          />
        </Form.Item>

        <Form.Item
          name={timeName}
          noStyle
          rules={[{ required: true, message: 'Select a time' }]}
        >
          <MobileTimePicker
            ampm={false}
            format="HH:mm"
            disabled={disabled}
            slotProps={{
              dialog: { sx: { zIndex: 9999 } },
              textField: {
                variant: 'standard',
                size: 'small',
                placeholder: 'HH:mm',
                InputProps: {
                  disableUnderline: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTimeIcon sx={{ fontSize: 16, color: 'rgba(0,0,0,0.54)', flexShrink: 0 }} />
                    </InputAdornment>
                  ),
                },
                sx: {
                  flexBasis: '33%',
                  flexGrow: 1,
                  '& input': {
                    padding: '6px',
                    fontSize: 14,
                    textAlign: 'right',
                  },
                  '& .MuiInputBase-root': inputStyle,
                },
              },
            }}
          />
        </Form.Item>
      </Box>
    </LocalizationProvider>
  );
}
